<div class="container-fluid g-0 m-0">
  <div class="row g-0 m-0 d-flex pt-5 pb-3 align-items-center">
    <div class="col-md-1 d-flex pe-4 justify-content-end">
      <div class="button-back pb-1" [routerLink]="['/scheduled/event-logs']">
        <svg-icon alt="Back" src="assets/core/back-button.svg"></svg-icon>
      </div>
    </div>
    <div class="col-md-11">
      <h2 class="col pb-2 m-0 title">
        {{ "EVENT_LOG_DATA" | translate }}
        {{ "DETAILS" | translate }}
      </h2>
      <h6 class="col subtitle">
        {{ "SCHEDULEDEVENTLOG_SUBTITLE" | translate }}
      </h6>
    </div>
  </div>
  @if (meterId) {
  <app-event-logs [meterId]="meterId"></app-event-logs>
  }
</div>
